import React, { Component } from 'react';
import * as validate from '../../util/validations';
import ScenarioForm from '../presentation/ScenarioManagement/ScenarioForm';
import {ScenarioTypes} from "../../enum/ScenarioEnum"

class EditScenarioWidget extends Component {
    state = {
        scenarios: [],
        selectedScenario: '',
        errorField: '',
        scenarioId: this.props.pageParameters && this.props.pageParameters[0] ? this.props.pageParameters[0] : null,
        formData: {
            name: '',
            apiKey: '',
            customerApiKey: '',
            projectId: '',
            accountId: '',
            email: '',
            state: 'Active',
            numberZones: 0,
            comments: '',
            environment: '',
            deviceDPH: 0,
            type: ScenarioTypes.FIELD,
            zones: []
        },
        formErrors: {},
    };

    componentDidMount() {
        if (this.state.scenarioId) {
            this.getSelectedScenario();
        }
    }

    getSelectedScenario = () => {
        fetch('/service/getScenario?scenarioId=' + this.state.scenarioId, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        }).then(response => {
            if (response.status !== 200) {
                this.setState({
                    error: 'An error has occurred fetching single scenario details',
                });
            } else {
                response.json().then(scenario => {
                    this.setState({
                        formData: {
                            name: scenario.name,
                            apiKey: scenario.apiKey,
                            customerApiKey: scenario.customerApiKey,
                            email: scenario.email,
                            numberZones: (scenario.zones && scenario.zones.length) || 0,
                            comments: scenario.comments,
                            environment: scenario.environment,
                            projectId: scenario.projectId,
                            accountId: scenario.accountId,
                            type: scenario.type || ScenarioTypes.FIELD,
                            deviceDPH: scenario.deviceDPH || 0
                        },
                    });
                });
            }
        });
    };

    validateInput = () => {
        const {name, email, apiKey, customerApiKey, environment, accountId, projectId, type, deviceDPH } = this.state.formData;
        if (validate.required(name)) {
            this.setState({
                formErrors: {
                    error: 'Please enter a Scenario name',
                    errorField: 'name',
                },
            });
        } else if (validate.required(email)) {
            this.setState({
                formErrors: { error: 'Please enter an Email', errorField: 'email' },
            });
        } else if (validate.required(apiKey)) {
            this.setState({
                formErrors: {
                    error: 'Please enter an Application API Key ',
                    errorField: 'apiKey',
                },
            });
        } else if (validate.required(customerApiKey)) {
            this.setState({
                formErrors: {
                    error: 'Please enter an Customer API Key',
                    errorField: 'customerApiKey',
                },
            });
        } else if (validate.required(accountId)) {
            this.setState({
                formErrors: {
                    error: 'Please enter an Account Id ',
                    errorField: 'accountId',
                },
            });
        } else if (validate.required(projectId)) {
            this.setState({
                formErrors: {
                    error: 'Please enter an Project Id',
                    errorField: 'projectId',
                },
            });
        } else if (validate.email(email)) {
            this.setState({
                formErrors: { error: 'Please enter a valid Email', errorField: 'email' },
            });
        } else if (validate.required(environment) || environment === 'Select environment') {
            this.setState({
                formErrors: {
                    error: 'Please select environment',
                    errorField: 'environment',
                },
            });
        } else if (deviceDPH && (deviceDPH < 0 || deviceDPH >= 100)) { 
            this.setState({
                formErrors: { error: 'Device DPH must be between 0 and 100', errorField: 'deviceDPH' },
            });
        } else if(!Object.values(ScenarioTypes).includes(type)) {
            this.setState({
                formErrors: { error: 'Scenario Type is not valid', errorField: 'type' },
            });
        } else {
            this.setState({ formErrors: { error: false } });
            return true;
        }
    };

    updateFormState = e => {
        let { target } = e;
        this.setState(prevState => {
            let { formData } = prevState;
            if (target.name === 'deviceDPH') {
                // convert deviceDPH to number from input string
                formData[target.name] = (target.value) ? parseFloat(target.value) : 0;
            } else {
                formData[target.name] = target.value;
            }
            return { formData };
        });
    };

    handleAddNewScenario = () => {
        const {name, apiKey, customerApiKey, accountId, projectId, email, numberZones, comments, environment, type, deviceDPH} = this.state.formData;
        let body = {
            name,
            apiKey,
            customerApiKey,
            accountId,
            projectId,
            email,
            numberZones,
            comments,
            environment,
            type,
            deviceDPH,
        };

        this.setState({ formErrors: { serverError: '', success: '' } });

        if (this.validateInput()) {
            fetch('/service/createScenario', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify(body),
            }).then(response => {
                if (response.status != 200) {
                    response.json().then(json => {
                        this.setState({ formErrors: { serverError: json.errorMessage } });
                    });
                } else {
                    this.setState({formErrors: {success: 'Scenario has been created successfully'}});
                }
            });
        }
    };

    handleEditScenario = () => {
        const {name, apiKey, customerApiKey, accountId, projectId, email, numberZones, comments, environment, type, deviceDPH} = this.state.formData;
        const body = {
            name,
            apiKey,
            customerApiKey,
            accountId,
            projectId,
            email,
            numberZones,
            comments,
            environment,
            type,
            deviceDPH,
            _id: this.state.scenarioId
        };

        this.setState({
            formErrors: {
                serverError: '',
                success: '',
            },
        });

        if (this.validateInput()) {
            fetch('/service/editScenario', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify(body),
            })
                .then(response => {
                    if (response.status !== 200) {
                        response.json().then(() => {
                            this.setState({
                                formErrors: { serverError: 'Error saving scenario' },
                            });
                        });
                    } else {
                        response.json().then(json => {
                            this.setState({formErrors: {success: 'Scenario has been updated successfully'}});
                        });
                    }
                })
                .catch(console.error);
        }
    };

    render() {
        const { scenarioId } = this.state;

        if (scenarioId) {
            return (
                <ScenarioForm
                    title="Edit Scenario"
                    buttonLabel="Update"
                    loadData={this.state}
                    scenarioId={scenarioId}
                    navigator={this.props.navigator}
                    updateFormState={this.updateFormState}
                    handleEditScenario={this.handleEditScenario}
                />
            );
        } else {
            return (
                <ScenarioForm
                    title="Add New Scenario"
                    buttonLabel="Create"
                    loadData={this.state}
                    navigator={this.props.navigator}
                    updateFormState={this.updateFormState}
                    handleAddNewScenario={this.handleAddNewScenario}
                />
            );
        }
    }
}

export default EditScenarioWidget;
